import { oauthEndpointProvidersPredicateFn } from '@/services/transport/errorsProcessing/rules/oauth/types'
import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmAuthAccountForBusinessUsersError } from '@/core/error/transport/auth/TmAuthAccountForBusinessUsersError'

export const oauthAccountIsForPersonalUseErrorRule: CustomErrorRule = {
  predicateFn: oauthEndpointProvidersPredicateFn,
  subCodes: ['auth.app_for_business_only'],
  klass: TmAuthAccountForBusinessUsersError,
}
